var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldTagCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "99311139-7563-4A34-9EF3-3C42D9757058") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-620.000000, -380.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-cross",
    transform: "translate(620.000000, 380.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2796869,3.75 C8.86968696,3.75 7.52968758,4.33999991 6.5796876,5.38999987 L3.0496875,9.27000046 C1.63968754,10.8200004 1.63968754,13.1799996 3.0496875,14.7299995 L6.5796876,18.6100006 C7.52968758,19.6500006 8.86968696,20.25 10.2796869,20.25 L16.9996872,20.25 C19.7596872,20.25 21.9996872,18.01 21.9996872,15.25 L21.9996872,8.75 C21.9996872,5.99000001 19.7596872,3.75 16.9996872,3.75 L10.2796869,3.75 Z M16.5296879,15 C16.3796879,15.15 16.1896872,15.2200003 15.9996872,15.2200003 C15.8096872,15.2200003 15.6196875,15.15 15.4696875,15 L13.5296869,13.0600004 L11.5896873,15 C11.4396873,15.15 11.2496876,15.2200003 11.0596876,15.2200003 C10.8696876,15.2200003 10.6796869,15.15 10.5296869,15 C10.2396869,14.71 10.2396869,14.2299996 10.5296869,13.9399996 L12.4696875,12 L10.5296869,10.0600004 C10.2396869,9.77000043 10.2396869,9.28999999 10.5296869,9 C10.8196869,8.71000001 11.2996874,8.71000001 11.5896873,9 L13.5296869,10.9399996 L15.4696875,9 C15.7596875,8.71000001 16.2396879,8.71000001 16.5296879,9 C16.8196879,9.28999999 16.8196879,9.77000043 16.5296879,10.0600004 L14.5896873,12 L16.5296879,13.9399996 C16.8196879,14.2299996 16.8196879,14.71 16.5296879,15 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTagCross);
export default __webpack_public_path__ + "static/media/vuesax-bold-tag-cross.0098b6479438b8de66a6ba393b08ee8d.svg";
export { ForwardRef as ReactComponent };